// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_2RMMnSwd8Huj4y1KDiroPm","body":"_3wfRPC_9qJyHfFb4nrIwsB","header":"NiWomNlS4dZNHj6vTQ430","title":"Oiy1VubI-6ga2klH3Y9FN","subTitle":"_2j7HA1TD5HeWAApT8NLJbO"};